export const environment = {
    production: true,
    apiUrl: 'https://dev-feedback.smartbooqing.nl/api'
};
